import { render, staticRenderFns } from "./modal-del.vue?vue&type=template&id=aa6a245a&scoped=true"
import script from "./modal-del.vue?vue&type=script&lang=js"
export * from "./modal-del.vue?vue&type=script&lang=js"
import style0 from "./modal-del.vue?vue&type=style&index=0&id=aa6a245a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a245a",
  null
  
)

export default component.exports